import { defineComponent } from '@/gr/common/knockout/defineComponent';

export class LoadingFillParentComponent {}

import html from './loadingFillParentComponent.html';
defineComponent(() => LoadingFillParentComponent, 'loadingFillParent', html);
require('./loadingFillParentComponent.less');
